export function ArrowDown({ color }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill={color}>
      <path d="M10 14a1 1 0 01-.755-.349L5.329 9.182a1.367 1.367 0 01-.205-1.46A1.184 1.184 0 016.2 7h7.6a1.18 1.18 0 011.074.721 1.357 1.357 0 01-.2 1.457l-3.918 4.473A1 1 0 0110 14z"></path>
    </svg>
  );
}

export default ArrowDown;
